// extracted by mini-css-extract-plugin
export default {"TopMenu":"TopMenu_TopMenu__-4mAW","TopMenuRight":"TopMenu_TopMenuRight__w-msT","logo":"TopMenu_logo__85Md6"};